import merge from 'deepmerge';

import type { Translations } from '../types';
import common from './common';
import customer from './customer';
import de from './de/web-customer-area.json';
import en from './en/web-customer-area.json';
import fr from './fr/web-customer-area.json';

const webCustomerArea = {
  fr: fr.web_customer_area,
  en: en.web_customer_area,
  de: de.web_customer_area,
};

export default merge.all<Translations>([common, customer, webCustomerArea]);
